























import {Vue, Component, Prop} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {Mall} from 'supporter';
const mallModule = namespace('mall');

@Component
export default class ProductPriorityTopContent extends Vue {
  @mallModule.Getter('malls') private malls!: Mall[];

  @Prop({required: false, default: false, type: Boolean})
  private isModified?:boolean;

  private get left(): number {
    if (!this.currentMallNo) return 0;
    const pos = this.mallNos.indexOf(this.currentMallNo) + 1;
    const containerWidth = $('.content_box.mall_list').width();
    const to = pos - Math.floor(containerWidth/112);
    if (to>=0) {
      return - to*112 - 112 + containerWidth%112
    } else {
      return 0;
    }
  }

  private get mallNos(): number[] {
    return this.malls.map((mall: Mall): number => mall.mallNo);
  }

  private currentMallNo: number = -1;

  private mallItemClick(mallNo: number) {
    if (this.isModified) {
      if (!confirm(this.$t('CHANGE_MALL_ALERT') as string)) {
        return;
      }
    }
    this.currentMallNo = mallNo;
    this.emitMallNo();
  }

  private btnClick(pattern: string) {
    if (this.isModified) {
      if (!confirm(this.$t('CHANGE_MALL_ALERT') as string)) {
        return;
      }
    }

    let idx = this.mallNos.indexOf(this.currentMallNo);
    if (pattern === 'prev') {
      if (idx > 0) {
        idx = idx - 1;
      } else {
        idx = this.mallNos.length - 1;
      }
    }
    if (pattern === 'next') {
      if (idx < this.mallNos.length - 1) {
        idx = idx + 1;
      } else {
        idx = 0;
      }
    }

    this.currentMallNo = this.mallNos[idx];
    this.emitMallNo();
  }

  private emitMallNo() {
    this.$emit('fireByMallNo', this.currentMallNo);
  }

  private mounted() {
    this.currentMallNo = this.mallNos[0];
    this.emitMallNo();
  }

   private get showTab() {
    let flg = false;
    if (this.malls && this.malls.length && this.malls.length > 1) {
      flg = true;
    }
    return flg;
  }
}
